import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from "flarum/forum/app";
import Component from "flarum/common/Component";
import humanTime from "flarum/common/helpers/humanTime";
import classList from "flarum/common/utils/classList";
import { ThreadsSkeleton } from "./Skeletons";
/**
 * The threads the actor takes part in, across every channel.
 *
 * The counterpart to the thread panel: the panel reads one thread, this is how
 * you find it again afterwards. Selecting a row routes to the panel over its own
 * channel.
 */
export default class ThreadsList extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "threads", []);
    _defineProperty(this, "loading", true);
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.load();
  }
  view() {
    if (this.loading) {
      return m("div", {
        className: "ChatThreadsList"
      }, ThreadsSkeleton());
    }
    if (this.threads.length === 0) {
      return m("div", {
        className: "ChatThreadsList"
      }, m("div", {
        className: "ChatBrowse-empty"
      }, app.translator.trans("ramon-chat.forum.thread.no_threads")));
    }
    return m("div", {
      className: "ChatThreadsList"
    }, this.threads.map(thread => this.row(thread)));
  }
  row(thread) {
    const channel = this.attrs.state.channel(thread.channelId());
    const at = thread.lastMessageAt();
    return m("button", {
      type: "button",
      key: thread.id(),
      className: classList("ChatThreadsList-row", {
        "ChatThreadsList-row--unread": thread.hasUnread()
      }),
      onclick: () => this.open(thread)
    }, m("i", {
      className: "ChatThreadsList-icon fas fa-comments",
      "aria-hidden": "true"
    }), m("div", {
      className: "ChatThreadsList-body"
    }, m("div", {
      className: "ChatThreadsList-title"
    }, thread.displayTitle()), m("div", {
      className: "ChatThreadsList-meta"
    }, channel ? m("span", null, channel.displayName()) : null, m("span", null, app.translator.trans("ramon-chat.forum.thread.replies", {
      count: thread.repliesCount()
    })), at ? m("span", null, humanTime(at)) : null)), thread.hasUnread() ? m("span", {
      className: "ChatThreadsList-badge"
    }, thread.unreadCount()) : null);
  }
  async load() {
    try {
      const results = await app.store.find("chat-threads", {
        filter: {
          participating: true
        },
        sort: "-lastMessageAt",
        page: {
          limit: 50
        }
      });
      this.threads = Array.isArray(results) ? results : [];
    } catch (_unused) {
      this.threads = [];
    } finally {
      this.loading = false;
      m.redraw();
    }
  }
  open(thread) {
    const channelId = thread.channelId();
    if (!channelId) return;
    this.attrs.state.setActiveChannel(channelId);
    this.attrs.state.activeThreadId = Number(thread.id());
    m.route.set(app.route("chat.thread", {
      id: channelId,
      threadId: thread.id()
    }));
  }
}
flarum.reg.add('ramon-chat', 'forum/components/ThreadsList', ThreadsList);